export const ONE_DAY_IN_MILLISECONDS = 86400000
